import { Text } from "../api/text";
export const text = (pos, body, attribs) => new Text(pos, body, attribs);
